import { Environment } from '../../../environments/environment';

export interface AvailableModelsParamsType {
  community: string;
  fields: string;
  id?: string;
  limit: number;
  offset: number;
}

export function AvailableModelsParams(): AvailableModelsParamsType {
  return {
    community: Environment.community,
    fields: 'baths,beds,garage,images,series,title,relatedModels',
    limit: 200,
    offset: 0,
  };
}
